import { useMatches } from '@remix-run/react';

import type { RootLoaderData } from '~/rootLoader';

export default function useEnv() {
  const root = useMatches()[0]!.data as RootLoaderData;

  return root.env;
}
